import { render, staticRenderFns } from "./SocialSignInButton.vue?vue&type=template&id=cc8d71bc&"
import script from "./SocialSignInButton.vue?vue&type=script&lang=js&"
export * from "./SocialSignInButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports